import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

const reopenPersonalChatSchema = z.object({
  id: z.string(),
});

export const reopenPersonalChat = mutator({
  schema: reopenPersonalChatSchema,
  resolve: {},
  permissions: {
    none: "personal chats are read and written only for ctx.userId",
  },
  fn: async ({ tx, ctx, args }) => {
    const { userId } = ctx;
    const [pc] = await tx.run(
      zql.personalChats.where("id", args.id).where("userId", userId)
    );
    if (!pc || pc.closedAt == null) return;
    await tx.mutate.personalChats.update({
      id: args.id,
      closedAt: null,
    });
  },
});
